/**
 * Read-side fallbacks for cue fields that old data can lack (21 Oct 2026).
 *
 * Cues from 2018-20 can have no data.label or data.time, or no data map at all. The legacy editor
 * tolerated that; the current cue header read cue.data.label.length and threw, so the header box did
 * not render. Same pattern as workNoteOf in worknotes.js. Reads only: writes are unchanged.
 */
const dataField = (cue, key) => {
    const v = cue && cue.data ? cue.data[key] : undefined;
    return v == null ? '' : v;
};

export const cueLabelOf = cue => dataField(cue, 'label');
export const cueTimeOf = cue => dataField(cue, 'time');


// WEBPACK FOOTER //
// ./src/lib/cue-fields.js